import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { telHref, waHref } from "@/lib/contact";
import { btn } from "@/lib/ui";
import { cn } from "@/lib/utils";
import { WhatsAppIcon } from "@/components/brand/WhatsAppIcon";

export const CallButton = ({ label = "Call for Appointment", className = "", testid = "call-btn", size = "md", tone = "blue" }) => {
  const { settings } = useSite();
  return (
    <a href={telHref(settings)} data-testid={testid} className={cn(btn(tone, size), className)}>
      <Phone className="h-4 w-4" aria-hidden="true" />
      {label}
    </a>
  );
};

export const WhatsAppButton = ({ label = "WhatsApp", message, className = "", testid = "whatsapp-btn", size = "md", tone = "wa" }) => {
  const { settings } = useSite();
  return (
    <a
      href={waHref(settings, message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={cn(btn(tone, size), className)}
    >
      <WhatsAppIcon className="h-5 w-5" />
      {label}
      <span className="sr-only">(opens WhatsApp)</span>
    </a>
  );
};
